import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type Status = 'healthy' | 'warning' | 'critical' | 'unknown';

const statusStyles: Record<Status, string> = {
  // Calm by default — healthy is the quietest state
  healthy: 'border-transparent bg-transparent text-muted-foreground font-normal',
  warning:
    'border-[var(--status-warning-fg)]/30 bg-[var(--status-warning-bg)] text-[var(--status-warning-fg)]',
  critical:
    'border-[var(--status-danger-fg)]/30 bg-[var(--status-danger-bg)] text-[var(--status-danger-fg)]',
  unknown: 'border-transparent bg-transparent text-muted-foreground font-normal',
};

export function StatusBadge({ status, label }: { status: Status; label?: string }) {
  return (
    <Badge variant="outline" className={cn(statusStyles[status])}>
      {label ?? status}
    </Badge>
  );
}
